<form class="biopharma-search-form">
  <div class="search-bar">
    <va-icon size="small" name="search" class="search-icon"></va-icon>
    <input
      type="text"
      id="biopharma-search-input"
      placeholder="Search for Indication, MOA, Target, Company, Drug Name, Drug Commercial Status..."
      [formControl]="myControl"
      [matAutocomplete]="auto"
      [(ngModel)]="searchQuery"
      (focusout)="clearSearch()"
      [ngClass]="[
        autocomplete && autocomplete.panelOpen ? 'hide-border' : 'show-border'
      ]"
    />
  </div>

  <mat-autocomplete
    autoActiveFirstOption
    #auto="matAutocomplete"
    class="biopharma-search-result-container"
    (optionSelected)="createNewFilter($event.option.value)"
    [displayWith]="displayFn"
  >
    <mat-option
      *ngFor="let option of filteredOptions | async"
      [value]="option"
      class="biopharma-search-result-option"
    >
      <div class="biopharma-search-result-div">
        <div class="db-link-container">
          <div *ngIf="showDbLink">
            <va-icon
              (click)="createNewFilter(option)"
              name="external-link"
              class="db-link-icon"
              size="small"
            ></va-icon>
          </div>
        </div>
        <div class="result-name">
          <span
            class="name"
            [title]="option.displayName"
            [innerHtml]="option.displayName | textHighlight: matchQueryString"
          ></span>
          <span class="count" *ngIf="option.count > 0">
            ({{ option.count }})</span
          >
        </div>
        <div class="facet-name">
          <span>{{ categoryNames[option.type] }}</span>
        </div>
        <div class="action-buttons">
          <span class="view-drug-btn btn">
            <va-button
              btnType="link"
              size="small"
              *ngIf="
                hasDrugPageAccess &&
                (option.type == 'drug' || option.type == 'alias')
              "
              (click)="redirectToDrugPage(option)"
            >
              <va-icon
                size="small"
                name="external-link"
                class="my-class"
              ></va-icon>
              View drug</va-button
            >
          </span>
          <span class="add-filter-btn btn">
            <va-button
              btnType="text"
              size="small"
              *ngIf="!showDbLink"
              [isDisabled]="option.filter_count == 0"
              (click)="addFilter(option)"
            >
              <va-icon size="small" name="plus" class="my-class"></va-icon>
              Add filter</va-button
            >
          </span>
        </div>
      </div>
    </mat-option>
  </mat-autocomplete>
</form>
